import {
  AfterViewInit, ChangeDetectorRef, Component,
  EventEmitter,
  Input, OnChanges, Output,
  AfterViewChecked,
  ViewEncapsulation
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  BooleanCons,
  LegendByAuthorizeOrder, MessageType, NumberCons, PaymentTypeInfo,
  PaymentTypeInfoCompare,
  RolesString,
  StatusPendingOrder
} from 'src/app/constants/const';
import { NotificationMessageComponent } from 'src/app/dialogs/notification-message/notification-message.component';
import { TypeIcon } from 'src/app/model/device/message.model';
import { CallPlace } from 'src/app/model/http/myActivity.model';
import { PaymentCard } from 'src/app/model/http/profile.model';
import { CartContentTypeCompare } from 'src/app/model/http/shoppingList';
import { DialogService } from 'src/app/services/dialog.service';
import { ObservableService } from 'src/app/services/observable.service';
import { StringConst } from '../../constants/const';
import { CallPlaceCompare } from '../../model/http/myActivity.model';
import { TotalDescriptionShopping } from '../../model/local/general.model';
import { CommonService } from '../../services/common.service';
import { WarningPromotionalCodeComponent } from 'src/app/dialogs/warning-promotional-code/warning-promotional-code.component';
import { MatDialogConfig } from '@angular/material/dialog';
@Component({
  selector: 'app-totals-description',
  templateUrl: './totals-description.component.html',
  styleUrls: ['./totals-description.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TotalsDescriptionComponent implements AfterViewInit, OnChanges, AfterViewChecked {
  @Input() isShoppingCard = BooleanCons.false;
  @Input() totalDescription = new TotalDescriptionShopping();
  @Input() showAsteriskPackages = BooleanCons.false;
  @Input() disable = BooleanCons.false;
  @Input() disableCostShipping = BooleanCons.false;
  @Input() disableCostDiscount = BooleanCons.false;
  @Input() isSmallLetters = BooleanCons.false;
  @Input() disableUtilities = BooleanCons.false;
  @Input() fullwidth = BooleanCons.false;
  @Input() rol = '';
  @Input() orderStatus = StringConst.empty;
  @Input() callPlace = CallPlace.default;
  @Input() showEditOrderButton = BooleanCons.false;
  @Input() paymentTypeCredit = StringConst.empty;
  @Input() showImage = BooleanCons.false;
  @Input() showButtons = BooleanCons.true;
  @Output() continueButton = new EventEmitter<boolean>();
  @Output() cancelButton = new EventEmitter<boolean>();
  @Output() editButton = new EventEmitter<boolean>();
  @Output() acceptButton = new EventEmitter<boolean>();
  @Output() editOrderButton = new EventEmitter<void>();
  @Output() printPdfEmitter = new EventEmitter<void>();
  @Input() paymentImage = StringConst.empty;
  @Input() paymentInformation = new PaymentCard();
  @Input() showFavorBalance = BooleanCons.false;
  @Input() favorBalanceTotal = NumberCons.zero;
  @Input() favorBalanceStatus = BooleanCons.false;
  @Output() selectionFavorBalanceChange = new EventEmitter<boolean>();
  @Input() showApplyCoupon = false;
  @Input() promotionalCode = StringConst.empty;
  @Input() validatePromoCode = BooleanCons.false;
  @Input() shippingCostDiscount = BooleanCons.false;
  @Input() shippingCostDiscountAmount = NumberCons.zero;
  @Input() isFromInvoiceDetail = BooleanCons.false;
  paymentTypeCompare = PaymentTypeInfoCompare;
  statusPendingOrder = StatusPendingOrder;
  roles = RolesString;
  callPlaceCompare = CallPlaceCompare;
  legendByAuthorizeOrder = LegendByAuthorizeOrder;
  isVerifyPrescriptionEnableBtn = BooleanCons.false;
  cartContentTypeCompare = CartContentTypeCompare;
  isAdvisorRole = BooleanCons.false;
  creditIcon = StringConst.empty;
  paymentTypeInfo = PaymentTypeInfo;
  inputPatter = { 0: { pattern: new RegExp('^[A-Za-zñÑáéíóúÁÉÍÓÚ0-9,]+$') } };
  therePromotionalCode = BooleanCons.false;
  promotionalCodeControl = new FormControl('', [Validators.minLength(5), Validators.maxLength(20)]);
  constructor(
    private commonService: CommonService,
    private cd: ChangeDetectorRef,
    private dialogService: DialogService,
    private observableService: ObservableService) { }

  ngOnChanges(): void {
    this.creditIcon = this.commonService.getIconOfPaymentMethod(
      PaymentTypeInfo.credit
    );
    this.isAdvisorRole = this.rol === RolesString.advisor;
    this.promotionalCodeControl.setValue(this.promotionalCode, { emitEvent: false });
    this.therePromotionalCode = this.commonService.validateValidString(this.promotionalCode);
  }
  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  clickOnContinueButton(): void {
    const promotionalCode = this.commonService.validateValidString(
      String(this.promotionalCodeControl.value)
    );
    if (this.commonService.validateAndValue([!promotionalCode, this.validatePromoCode])) {
      this.showMessageDialog();
    } else {
      this.continue();
    }
  }

  showMessageDialog(): void {
    const config = new MatDialogConfig();
    this.dialogService.displayDialog(WarningPromotionalCodeComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.continue();
      }
    });
  }

  continue(): void {
    this.continueButton.emit(true);
  }

  editAndShopping(): void {
    this.editButton.emit(true);
  }
  clickOnCanceledButton(): void {
    this.cancelButton.emit(true);
  }

  clickOnAcceptButton(): void {
    this.acceptButton.emit(true);
  }
  editOrder(): void {
    this.editOrderButton.emit();
  }
  printPdf(): void {
    this.printPdfEmitter.emit();
  }
  change(event: any): void {
    const value = event.target?.value ?? StringConst.empty;
    if (value === StringConst.empty) {
      this.clearPromotionalCode();
    }
  }
  favorBalanceChange(event: any): void {
    event.preventDefault();
    const total = this.commonService.calculateTernary(
      this.totalDescription.hasDiscountSpecial,
      this.totalDescription.totalWithSpecialDiscount,
      this.totalDescription.total
    );
    if ((total - 10) < this.favorBalanceTotal) {
      this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
        textToShow: 'Para poder utilizar el saldo a favor el pago restante debe ser mayor por un mínimo de $10.00 pesos',
        typeIcon: TypeIcon.info,
        typeMessage: MessageType.default,
      });
    } else {
      this.selectionFavorBalanceChange.emit(!this.favorBalanceStatus);
    }
  }
  clearPromotionalCode(): void {
    this.promotionalCodeControl.setValue('');
    this.observableService.setCouponCode(StringConst.empty);
  }
  applyPromotionalCode(): void {
    this.observableService.setCouponCode(String(this.promotionalCodeControl.value).toUpperCase());
  }
}
